<template>
    <div>
        <div class="topImgCtn">
            <img class="titleImg" src="../assets/RegisterNew/用户服务协议title.png" height="260" width="1280"/>
        </div>
        <div style="width: 1121px;height: auto;padding-top:67px;padding-bottom: 67px;margin-left: auto;margin-right: auto;">
            <img src="../assets/RegisterNew/用户服务协议content.png" height="2689" width="1120"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ServiceAgreement"
    }
</script>

<style scoped>
    .contentImg{
        position:relative;
        left:50%;
        margin-left: -560px;
    }
    .titleImg{
        position:absolute;
        bottom:0px;
        left:50%;
        margin-left: -640px;
    }
    .topImgCtn{
        position:relative;
        background-image:url('../assets/RegisterNew/用户服务协议.jpg') ;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position:relative;
        width: 100vw;
        height:40vw;
    }
</style>